var React = require('react');

function IcArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 3C0 1.34314 1.34315 0 3 0H56V56H3C1.34314 56 0 54.6569 0 53V3Z","fill":"#FECC37","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28.214 38.1273L38.9127 28.818L39.7797 28.0637L38.9127 27.3093L28.214 18L26.9012 19.5088L35.5882 27.0676L16.9998 27.3969L16 27.4146L16.0354 29.4142L17.0353 29.3965L35.5785 29.0681L26.9012 36.6185L28.214 38.1273Z","fill":"white","key":1})]);
}

IcArrow.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = IcArrow;

IcArrow.default = IcArrow;
